import { useRouteColor } from "hooks/useRouteColors";
import ScrollTo from "../hooks/ScrollTo";
import React from "react";

function Header({
  infoColor,
  info,
  linkToSection,
  botonDescripcion,
  img,
  titulo,
  titleColor = "#0d2334",
  buttonColor = "#ffff86",
  buttonBg = "#0d2334",
}) {
  const { bg } = useRouteColor();
  return (
    <section
      className={`w-full flex flex-col items-center overflow-hidden transition-all duration-500 ease-in-out`}
    >
      {/* Contenedor principal del contenido */}
      <div className="w-full px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 pb-8 sm:pb-12 md:pb-16 lg:pb-20 xl:pb-32 pt-16 sm:pt-20 md:pt-28 lg:pt-32 xl:pt-40 flex flex-col gap-3 sm:gap-4 md:gap-5 justify-end texpri">
        {/* Título principal */}
        <h1
          className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-Bebas font-bold`}
          style={{ color: titleColor }}
        >
          {titulo}
        </h1>

        {/* Descripción */}
        <p
          className={`w-full sm:w-5/6 md:w-4/5 lg:w-3/4 xl:w-1/2 text-base sm:text-lg md:text-xl xl:text-2xl hyphens-none leading-relaxed`}
          style={{ color: infoColor }}
        >
          {info}
        </p>
        {/* Botón */}
        <div className="self-end">
          <ScrollTo
            to={linkToSection}
            text={botonDescripcion}
            buttonBg={buttonBg}
            buttonColor={buttonColor}
          />
        </div>
      </div>

      {/* Contenedor de la imagen */}
      <div className="w-full h-[40vh] sm:h-[50vh] md:h-[70vh] overflow-hidden">
        <img src={img} alt={titulo} className="object-cover w-full h-full" />
      </div>
    </section>
  );
}

export default Header;
